// 在worker.js中导出一个worker的方法
export function entitiesWorker() {
  // 当收到主线程来信的时候需要做的处理
  const baseURL = "https://static-lib.truckerimg.com/fleet-weather/";
  self.onmessage = (message) => {
    // 请求接口
    let stateCode = message.data.stateCode;
    fetch(
      baseURL +
        `fleet-weather-alert-location-${stateCode}.json?env=${process.env.VUE_APP_BUILD_ENV}`,
      {
        method: "GET",
      }
    )
      .then((r) => r.json())
      .then((r) => {
        self.postMessage({
          code: 200,
          stateCode: stateCode,
          data: r,
        });
      })
      .catch((error) => {
        self.postMessage({
          code: 500,
          stateCode: stateCode,
          data: error,
        });
      });
  };
}

// 主线程
// 由于web Worker只能通过url引入，同时还有同源策略所以需要我们自己处理worker.js文件
// transWorker 是我们转worker的工具
// 将worker转成一个IIFE之后封装成一个blob 然后传入worker。
export const transWorker = (worker) => {
  let blob = new Blob(["(" + worker.toString() + ")()"], {
    type: "application/javascript",
  });
  return new Worker(URL.createObjectURL(blob));
};
let createApiWorker = () => transWorker(entitiesWorker);
export default createApiWorker;
